/* JLS motion v2 — Lenis smooth scroll + GSAP ScrollTrigger.
   Intro hero (clip + chars), clip-reveal sulle foto, parallax, bigtext a velocità,
   marquee skew. Degrada a statico: senza JS/GSAP o con reduced-motion tutto è visibile. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CDN = {
    gsap: 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js',
    st: 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
    lenis: 'https://cdn.jsdelivr.net/npm/lenis@1.3.11/dist/lenis.min.js'
  };

  function load(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.defer = true; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function splitChars(el) {
    var text = el.textContent;
    el.textContent = '';
    el.classList.add('jls-split-mask');
    var frag = document.createDocumentFragment();
    for (var i = 0; i < text.length; i++) {
      var c = document.createElement('span');
      c.className = 'jls-char';
      c.style.display = 'inline-block';
      c.style.willChange = 'transform';
      c.textContent = text[i] === ' ' ? ' ' : text[i];
      frag.appendChild(c);
    }
    el.appendChild(frag);
    return el.querySelectorAll('.jls-char');
  }

  function init() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    gsap.registerPlugin(ST);

    /* ---- Lenis smooth scroll, agganciato al ticker GSAP ---- */
    var lenis = null;
    if (window.Lenis) {
      lenis = new window.Lenis({ lerp: 0.11, wheelMultiplier: 1, smoothWheel: true });
      lenis.on('scroll', ST.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    /* ---- Intro hero: clip dell'immagine + scale + titolo per-carattere ---- */
    var hero = document.querySelector('[data-jls-hero]');
    if (hero) {
      var media = hero.querySelector('[data-jls-hero-media]');
      var img = media && media.querySelector('img');
      var title = hero.querySelector('.jls-chero__title');
      var meta = hero.querySelectorAll('.jls-chero__meta span, .jls-chero__hint');
      var tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
      if (media && img) {
        tl.fromTo(media, { clipPath: 'inset(12% 6% 12% 6%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.4 }, 0)
          .fromTo(img, { scale: 1.28 }, { scale: 1, duration: 1.8 }, 0);
      }
      if (title) {
        var chars = splitChars(title);
        tl.fromTo(chars, { yPercent: 115 }, { yPercent: 0, duration: 1.0, stagger: 0.035, ease: 'power3.out' }, 0.45);
      }
      if (meta.length) tl.fromTo(meta, { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: 0.7, stagger: 0.08 }, 1.0);
      if (title) tl.add(function () { title.classList.add('is-filled'); }, 1.55);
      setTimeout(function () {
        var targets = [media, img, meta];
        if (title) targets.push(title.querySelectorAll('.jls-char'));
        targets.forEach(function (t) { if (t) gsap.set(t, { clearProps: 'all' }); });
      }, 4000);

      /* micro-parallax del hero in uscita */
      if (img) {
        gsap.to(img, { yPercent: 12, ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      }
    }

    /* ---- Editoriali: clip-reveal dal basso + scale interna ---- */
    gsap.utils.toArray('[data-jls-reveal]').forEach(function (fig) {
      var inner = fig.querySelector('img') || fig;
      var tween = gsap.timeline({
        scrollTrigger: { trigger: fig, start: 'top 86%', once: true,
          onEnter: function () {
            setTimeout(function () { gsap.set([fig, inner], { clearProps: 'all' }); }, 3000);
          } }
      });
      tween.fromTo(fig, { clipPath: 'inset(18% 0% 0% 0%)', yPercent: 6 },
                        { clipPath: 'inset(0% 0% 0% 0%)', yPercent: 0, duration: 1.2, ease: 'power4.out' }, 0)
           .fromTo(inner, { scale: 1.18 }, { scale: 1, duration: 1.6, ease: 'power3.out' }, 0);
    });

    /* ---- Parallax scrub dentro le editoriali ---- */
    gsap.utils.toArray('[data-jls-parallax]').forEach(function (el) {
      var img = el.querySelector('img') || el;
      gsap.fromTo(img, { yPercent: -5 }, { yPercent: 5, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    /* ---- Feature text (drop entry / manifesto): parole che salgono ---- */
    gsap.utils.toArray('.feature-text').forEach(function (el) {
      var lines = el.querySelectorAll('p');
      if (!lines.length) return;
      gsap.fromTo(lines, { y: 34, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.9, stagger: 0.12, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true,
            onEnter: function () {
              setTimeout(function () { gsap.set(lines, { clearProps: 'all' }); }, 3000);
            } } });
    });

    /* ---- Bigtext: drift continuo + spinta/skew dalla velocità di scroll ---- */
    document.querySelectorAll('[data-jls-velocity-track]').forEach(function (track) {
      var x = 0, vel = 0;
      var groupW = track.scrollWidth / track.children.length;
      ST.create({
        trigger: track.closest('section'), start: 'top bottom', end: 'bottom top',
        onUpdate: function (self) { vel = self.getVelocity() / 220; }
      });
      gsap.ticker.add(function () {
        var speed = 0.6 + Math.min(Math.abs(vel), 9);
        x -= speed;
        if (-x >= groupW) x += groupW;
        var skew = gsap.utils.clamp(-7, 7, vel);
        track.style.transform = 'translateX(' + x + 'px) skewX(' + skew + 'deg)';
        vel *= 0.94;
      });
    });

    /* ---- Cursore custom (solo pointer fine) ---- */
    var cursor = document.querySelector('.jls-cursor');
    if (cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var cx = -100, cy = -100, ctx2 = -100, cty = -100;
      document.addEventListener('mousemove', function (e) {
        ctx2 = e.clientX; cty = e.clientY; cursor.classList.add('is-active');
      }, { passive: true });
      document.addEventListener('mousedown', function () { cursor.classList.add('is-down'); });
      document.addEventListener('mouseup', function () { cursor.classList.remove('is-down'); });
      gsap.ticker.add(function () {
        cx += (ctx2 - cx) * 0.2; cy += (cty - cy) * 0.2;
        cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      });
      document.querySelectorAll('a, button, input, .jls-marquee__item, .product-tile, [role="button"]').forEach(function (el) {
        el.addEventListener('mouseenter', function () { cursor.classList.add('is-hover'); });
        el.addEventListener('mouseleave', function () { cursor.classList.remove('is-hover'); });
      });
    }

    /* ---- Orologio live (Europe/Rome) nel hero ---- */
    var clockEl = document.querySelector('[data-jls-clock]');
    if (clockEl) {
      var fmt = new Intl.DateTimeFormat('it-IT', { timeZone: 'Europe/Rome', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var tick = function () { clockEl.textContent = fmt.format(new Date()); };
      tick(); setInterval(tick, 1000);
    }

    /* ---- Hover zoom su card prodotto ---- */
    document.querySelectorAll('.product-tile img').forEach(function (img) {
      img.style.transition = 'transform .7s cubic-bezier(.22,1,.36,1)';
      img.addEventListener('mouseenter', function () { img.style.transform = 'scale(1.045)'; });
      img.addEventListener('mouseleave', function () { img.style.transform = 'scale(1)'; });
    });

    ST.refresh();
  }

  function boot() {
    var chain = Promise.resolve();
    if (!window.gsap) chain = chain.then(function () { return load(CDN.gsap); });
    chain = chain.then(function () { return window.ScrollTrigger ? null : load(CDN.st); })
      .then(function () { return window.Lenis ? null : load(CDN.lenis).catch(function () {}); })
      .then(init)
      .catch(function () { /* niente motion: pagina statica completa */ });
  }

  var style = document.createElement('style');
  style.textContent = '.jls-split-mask{overflow:hidden;}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
